import { Fragment, ReactElement } from 'react';
import ResearchCohabitationNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-cohabitation';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCohabitationNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCohabitationNotificationCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchCohabitationNotificationCivilStatusPage.displayName =
  'Research Cohabitation Notifications Page component';

export default ResearchCohabitationNotificationCivilStatusPage;
